export default __webpack_public_path__ + "static/media/restaurant_menu_FILL0_wght400_GRAD0_opsz24.57ac300a.svg";